import React, { useEffect, useState } from "react";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as Back } from "../../assets/svgs/back-square.svg";
import ResetPassword from "./OrganizationDetails/ResetPassword";
//import ContactDeatils from "./ContactDetails/ContactDetails";
import MyProfile from "./MyProfile/MyProfile";

const Profile = () => {
  const [openMyProfile, setOpenMyProfile] = useState(true);
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [openContactdetails, setOpenContactDetails] = useState(false);

  return (
    <div style={{ padding: "20px", backgroundColor: "#fff" }}>
      <div>
        <div
          className="flex justify-end  text-xs"
          style={{ fontFamily: "Calibri" }}
        >
          <p>Home</p>
          <span> / </span>
          <TextStyles color="gradient">Profile</TextStyles>
        </div>
        <div className="flex items-center px-2  gap-2 text-xl  font-bold">
          {/* <Back /> */}
          <TextStyles color="gradient" style={{ marginTop: "20px" }}>
            {" "}
            Profile
          </TextStyles>
        </div>
        <div
          style={{
            border: "1px solid #3BA2B959",
            borderRadius: "10px",
            paddingTop: "20px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
          }}
        >
          <div className="flex">
            <div className="w-64 font-light gap-4 leading-10 ">
              <ul>
                <li
                  onClick={() => {
                    setOpenContactDetails(false);
                    setOpenResetPassword(false);
                    setOpenMyProfile(true);
                  }}
                  className="cursor-pointer"
                >
                  {openMyProfile ? (
                    <div className="text-[#06513D] bg-[#def5fa] mr-4 ">
                      <p className="pl-8">My Profile </p>
                    </div>
                  ) : (
                    <p className="pl-8"> My Profile </p>
                  )}
                </li>
                <li
                  onClick={() => {
                    setOpenContactDetails(false);
                    setOpenResetPassword(true);
                    setOpenMyProfile(false);
                  }}
                  className="cursor-pointer"
                >
                  {openResetPassword ? (
                    <div className="text-[#06513D] bg-[#def5fa] mr-4 ">
                      <p className="pl-8">Reset Password</p>
                    </div>
                  ) : (
                    <p className="pl-8">Reset Password </p>
                  )}
                </li>
              </ul>
            </div>

            <div
              style={{
                border: "1px solid #3BA2B959",
                borderRadius: "10px",
                paddingTop: "20px",
                boxShadow: "0px 0px 16px 0px #3BA2B91F",
                backgroundColor: "#fff",
              }}
              className="mr-4 mb-4 w-full pl-5 pb-5"
            >
              {openMyProfile ? (
                <MyProfile />
              ) : openResetPassword ? (
                <ResetPassword />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
